module.exports = __webpack_public_path__ + "static/media/opms_square_blue.57147856.png";